import React from 'react';
import { useRouteMatch } from 'react-router';
import BusinessDetail from '../../../components/BusinessDetail/BusinessDetail';
import Page from '../../../components/Page/Page';
import { useGetBusinessQuery } from '../../../redux/api';
import Spinner from '../../../components/Spinner/Spinner';

const UserBusinessPage: React.FC = () => {
  const match = useRouteMatch<{
    locationName: string;
    companyType: string;
    businessId: string;
  }>();
  const businessId = match.params.businessId;

  const {
    data: business,
    isLoading,
    isFetching,
  } = useGetBusinessQuery({ id: businessId });

  return (
    <Page headerProps={{}} pageLimitDisabled disableDefaultIonContent>
      {isFetching || isLoading || !business ? (
        <Spinner hasCountdown />
      ) : (
        <BusinessDetail business={business} />
      )}
    </Page>
  );
};

export default React.memo(UserBusinessPage);
